import { copyTextToClipboard } from './clipboard-copy';

export type OpenAnydeskResult = 'launched' | 'copied-fallback';

/**
 * Try the AnyDesk custom protocol. If the browser/OS has no handler
 * (page stays focused), copy the ID so it can be pasted into AnyDesk.
 * Avoids always opening go.anydesk.com (often unreachable / useless for aliases).
 */
export function openAnydeskId(anydeskId: string, timeoutMs = 1600): Promise<OpenAnydeskResult> {
  if (!anydeskId) {
    return Promise.resolve('copied-fallback');
  }

  return new Promise((resolve) => {
    let settled = false;

    const cleanup = () => {
      window.removeEventListener('blur', onBlur);
      document.removeEventListener('visibilitychange', onVisibility);
    };

    const markLaunched = () => {
      if (settled) {
        return;
      }
      settled = true;
      cleanup();
      resolve('launched');
    };

    const onBlur = () => markLaunched();
    const onVisibility = () => {
      if (document.hidden) {
        markLaunched();
      }
    };

    window.addEventListener('blur', onBlur);
    document.addEventListener('visibilitychange', onVisibility);

    const anchor = document.createElement('a');
    anchor.href = 'anydesk://' + anydeskId;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    setTimeout(() => {
      if (settled) {
        return;
      }
      settled = true;
      cleanup();
      void copyTextToClipboard(anydeskId)
        .catch(() => undefined)
        .finally(() => resolve('copied-fallback'));
    }, timeoutMs);
  });
}
